<div class="min-h-screen text-sm dark:bg-slate-900 p-4 md:p-8 text-slate-600 dark:text-slate-300">
  <div class="flex flex-col md:flex-row md:items-end justify-between mb-6 gap-4">
    <div>
      <h1 class="text-3xl font-extrabold text-slate-800 dark:text-slate-100 tracking-tight">เมนู LIFF Home</h1>
      <p class="text-slate-500 dark:text-slate-400 mt-2 font-medium">
        Import JSON = คลังเมนูทั้งหมด · จากนั้นเลือกวางลง Quick / More ได้เอง
      </p>
      <p class="text-xs text-amber-600 dark:text-amber-400 mt-1">
        Quick สูงสุด {{ quickMaxVisible }} รายการที่แสดง · ปุ่ม «เพิ่มเติม» อยู่ท้ายเสมอ
        <span *ngIf="isDefaultConfig()"> · กำลังใช้ค่า default (ยังไม่มีใน DB)</span>
      </p>
    </div>
    <div class="flex flex-wrap items-center gap-2">
      <button type="button" (click)="loadConfig()" [disabled]="isLoading() || isSaving()"
        class="px-4 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900 font-bold flex items-center gap-2">
        <span class="material-icons text-[18px]">refresh</span>
        โหลดจาก API
      </button>
      <button type="button" (click)="exportJson()" [disabled]="!config()"
        class="px-4 py-2.5 rounded-xl bg-emerald-500 text-white font-bold flex items-center gap-2">
        <span class="material-icons text-[18px]">download</span>
        Export JSON
      </button>
      <a href="/json/liff_home_menu_config.default.json" download="liff_home_menu_config.default.json"
        class="px-4 py-2.5 rounded-xl bg-slate-600 text-white font-bold flex items-center gap-2 no-underline">
        <span class="material-icons text-[18px]">description</span>
        Template JSON
      </a>
      <button type="button" (click)="fileInput.click()" [disabled]="!canUpdate || isSaving()"
        class="px-4 py-2.5 rounded-xl bg-blue-500 text-white font-bold flex items-center gap-2">
        <span class="material-icons text-[18px]">upload</span>
        Import JSON
      </button>
      <input #fileInput type="file" class="hidden" accept=".json" (change)="onFileSelected($event)" />
      <button type="button" *ngIf="canShowActivityHistory" (click)="openActivityHistory()"
        class="px-4 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 font-bold flex items-center gap-2">
        <span class="material-icons text-[18px]">history</span>
        ประวัติ
      </button>
      <button type="button" (click)="onSave()" [disabled]="!canUpdate || isSaving() || !config()"
        class="px-5 py-2.5 rounded-xl bg-amber-400 hover:bg-amber-500 text-white font-bold flex items-center gap-2 disabled:opacity-50">
        <span class="material-icons text-[18px]">save</span>
        บันทึก
      </button>
    </div>
  </div>

  <app-pss-loading *ngIf="isLoading()"></app-pss-loading>

  <div *ngIf="!isLoading() && config()" class="bg-white/95 dark:bg-slate-900/95 rounded-2xl shadow-xl border border-slate-100/50 overflow-hidden">
    <div class="flex border-b border-slate-100 dark:border-slate-800">
      <button type="button" (click)="setTab('catalog')"
        class="flex-1 py-4 font-bold transition-colors"
        [class.text-amber-600]="activeTab() === 'catalog'"
        [class.border-b-2]="activeTab() === 'catalog'"
        [class.border-amber-500]="activeTab() === 'catalog'">
        คลัง ({{ sortedCatalog().length }})
      </button>
      <button type="button" (click)="setTab('quick')"
        class="flex-1 py-4 font-bold transition-colors"
        [class.text-amber-600]="activeTab() === 'quick'"
        [class.border-b-2]="activeTab() === 'quick'"
        [class.border-amber-500]="activeTab() === 'quick'">
        Quick ({{ quickVisibleCount() }}/{{ quickMaxVisible }})
      </button>
      <button type="button" (click)="setTab('more')"
        class="flex-1 py-4 font-bold transition-colors"
        [class.text-amber-600]="activeTab() === 'more'"
        [class.border-b-2]="activeTab() === 'more'"
        [class.border-amber-500]="activeTab() === 'more'">
        More
      </button>
    </div>

    <!-- Catalog -->
    <div *ngIf="activeTab() === 'catalog'" class="p-4 md:p-6 space-y-3">
      <div class="flex flex-col sm:flex-row sm:items-center justify-between gap-2 mb-2">
        <p class="text-xs text-slate-500">
          เพิ่ม/แก้เมนูในคลังได้เอง (ฟิลด์ที่ LIFF Home ต้องใช้ห้ามว่าง) หรือ Import JSON · จากนั้นไปวางใน Quick/More
        </p>
        <button type="button" *ngIf="canUpdate" (click)="openCreateCatalogItem()"
          class="px-4 py-2 rounded-xl bg-amber-400 text-white font-bold flex items-center gap-1 shrink-0">
          <span class="material-icons text-[18px]">add</span>
          เพิ่มเมนู
        </button>
      </div>
      <div *ngFor="let item of sortedCatalog(); trackBy: trackCatalog"
        class="flex flex-col md:flex-row md:items-center gap-3 p-4 rounded-xl border border-slate-100 dark:border-slate-800 bg-slate-50/80 dark:bg-slate-800/40">
        <div class="flex-1 grid grid-cols-1 md:grid-cols-3 gap-2 text-xs md:text-sm">
          <div><span class="text-slate-400">key</span> <span class="font-mono font-semibold">{{ item.key }}</span></div>
          <div><span class="text-slate-400">route</span> <span class="font-mono">{{ item.route }}</span></div>
          <div><span class="text-slate-400">nameTH</span> {{ item.nameTH }}</div>
        </div>
        <div class="text-xs font-medium text-indigo-600 dark:text-indigo-300 shrink-0">
          {{ placementLabel(item.key) }}
        </div>
        <div class="flex gap-1 shrink-0" *ngIf="canUpdate">
          <button type="button" (click)="openEditCatalogItem(item)"
            class="p-2 rounded-lg border border-slate-200 dark:border-slate-700" title="แก้ไข">
            <span class="material-icons text-base">edit</span>
          </button>
          <button type="button" *ngIf="!isMorePin(item)" (click)="deleteCatalogItem(item)"
            class="p-2 rounded-lg border border-rose-200 text-rose-500" title="ลบจากคลัง">
            <span class="material-icons text-base">delete_outline</span>
          </button>
        </div>
      </div>
      <p *ngIf="!sortedCatalog().length" class="text-center text-slate-400 py-8">ยังไม่มีคลัง — กด «เพิ่มเมนู» หรือ Import JSON</p>
    </div>

    <!-- Quick -->
    <div *ngIf="activeTab() === 'quick'" class="p-4 md:p-6 space-y-3">
      <div *ngIf="canUpdate" class="flex flex-col sm:flex-row gap-2 p-3 rounded-xl bg-amber-50/80 dark:bg-amber-950/30 border border-amber-100 dark:border-amber-900/40">
        <select class="flex-1 rounded-xl border border-slate-200 dark:border-slate-700 px-3 py-2 bg-white dark:bg-slate-900"
          [(ngModel)]="addQuickKey">
          <option value="">— เลือกจากคลังเพื่อเพิ่ม Quick —</option>
          <option *ngFor="let c of catalogAvailableForQuick()" [value]="c.key">
            {{ c.nameTH }} ({{ c.key }})
          </option>
        </select>
        <button type="button" (click)="addToQuick()" [disabled]="!addQuickKey"
          class="px-4 py-2 rounded-xl bg-amber-400 text-white font-bold disabled:opacity-40 flex items-center gap-1 justify-center">
          <span class="material-icons text-[18px]">add</span>
          เพิ่ม Quick
        </button>
      </div>

      <div *ngFor="let item of sortedQuick(); trackBy: trackQuick"
        class="flex flex-col md:flex-row md:items-center gap-3 p-4 rounded-xl border border-slate-100 dark:border-slate-800 bg-slate-50/80 dark:bg-slate-800/40">
        <div class="flex items-center gap-2 shrink-0">
          <button type="button" (click)="moveQuick(item, -1)" [disabled]="isMorePin(item)"
            class="p-1 rounded-lg border border-slate-200 dark:border-slate-700 disabled:opacity-30">
            <span class="material-icons text-base">arrow_upward</span>
          </button>
          <button type="button" (click)="moveQuick(item, 1)" [disabled]="isMorePin(item)"
            class="p-1 rounded-lg border border-slate-200 dark:border-slate-700 disabled:opacity-30">
            <span class="material-icons text-base">arrow_downward</span>
          </button>
          <span class="text-xs font-mono text-slate-400 w-6 text-center">{{ item.sortOrder }}</span>
        </div>
        <div class="flex-1 grid grid-cols-1 md:grid-cols-3 gap-2 text-xs md:text-sm">
          <div><span class="text-slate-400">key</span> <span class="font-mono font-semibold">{{ item.key }}</span></div>
          <div><span class="text-slate-400">route</span> <span class="font-mono">{{ item.route }}</span></div>
          <div><span class="text-slate-400">nameTH</span> {{ item.nameTH }}</div>
        </div>
        <select class="rounded-xl border border-slate-200 dark:border-slate-700 px-3 py-2 bg-white dark:bg-slate-900 min-w-[140px]"
          [ngModel]="item.visibility" (ngModelChange)="onQuickVisibilityChange(item, $event)" [disabled]="!canUpdate">
          <option *ngFor="let opt of visibilityOptions" [value]="opt.value">{{ opt.label }}</option>
        </select>
        <button type="button" *ngIf="canUpdate && !isMorePin(item)" (click)="removeFromQuick(item)"
          class="p-2 rounded-lg border border-rose-200 text-rose-500 hover:bg-rose-50 dark:hover:bg-rose-950/40"
          title="เอาออกจาก Quick">
          <span class="material-icons text-base">remove_circle_outline</span>
        </button>
      </div>
    </div>

    <!-- More -->
    <div *ngIf="activeTab() === 'more'" class="p-4 md:p-6 space-y-6">
      <div *ngFor="let cat of sortedMoreCategories(); trackBy: trackCategory" class="rounded-xl border border-slate-100 dark:border-slate-800 overflow-hidden">
        <div class="px-4 py-3 bg-slate-100/80 dark:bg-slate-800/60 font-bold text-slate-700 dark:text-slate-200 flex flex-wrap items-center justify-between gap-2">
          <div>
            {{ cat.categoryTH }}
            <span class="text-xs font-normal text-slate-400 ml-2">({{ cat.categoryKey }})</span>
          </div>
          <div *ngIf="canUpdate" class="flex flex-wrap gap-2 items-center font-normal">
            <select class="rounded-lg border border-slate-200 dark:border-slate-700 px-2 py-1.5 text-xs bg-white dark:bg-slate-900 min-w-[160px]"
              [(ngModel)]="addMoreKeyByCategory[cat.categoryKey]">
              <option value="">— เพิ่มจากคลัง —</option>
              <option *ngFor="let c of catalogAvailableForMoreCategory()[cat.categoryKey] || []" [value]="c.key">
                {{ c.nameTH }} ({{ c.key }})
              </option>
            </select>
            <button type="button" (click)="addToMore(cat)" [disabled]="!addMoreKeyByCategory[cat.categoryKey]"
              class="px-3 py-1.5 rounded-lg bg-amber-400 text-white text-xs font-bold disabled:opacity-40">
              เพิ่ม
            </button>
          </div>
        </div>
        <div class="divide-y divide-slate-100 dark:divide-slate-800">
          <div *ngFor="let item of cat.items; trackBy: trackMoreItem"
            class="flex flex-col md:flex-row md:items-center gap-3 p-4">
            <div class="flex items-center gap-2 shrink-0">
              <button type="button" (click)="moveMoreItem(cat, item, -1)"
                class="p-1 rounded-lg border border-slate-200 dark:border-slate-700">
                <span class="material-icons text-base">arrow_upward</span>
              </button>
              <button type="button" (click)="moveMoreItem(cat, item, 1)"
                class="p-1 rounded-lg border border-slate-200 dark:border-slate-700">
                <span class="material-icons text-base">arrow_downward</span>
              </button>
            </div>
            <div class="flex-1 grid grid-cols-1 md:grid-cols-3 gap-2 text-xs md:text-sm">
              <div><span class="text-slate-400">key</span> <span class="font-mono font-semibold">{{ item.key }}</span></div>
              <div><span class="text-slate-400">route</span> <span class="font-mono">{{ item.route }}</span></div>
              <div><span class="text-slate-400">nameTH</span> {{ item.nameTH }}</div>
            </div>
            <select *ngIf="canUpdate && sortedMoreCategories().length > 1"
              class="rounded-xl border border-slate-200 dark:border-slate-700 px-2 py-2 bg-white dark:bg-slate-900 text-xs min-w-[120px]"
              [ngModel]="cat.categoryKey"
              (ngModelChange)="moveToMoreCategory(cat, item, $event)">
              <option *ngFor="let c of sortedMoreCategories()" [value]="c.categoryKey">{{ c.categoryTH }}</option>
            </select>
            <select class="rounded-xl border border-slate-200 dark:border-slate-700 px-3 py-2 bg-white dark:bg-slate-900 min-w-[140px]"
              [ngModel]="item.visibility" (ngModelChange)="onMoreVisibilityChange(item, $event)" [disabled]="!canUpdate">
              <option *ngFor="let opt of visibilityOptions" [value]="opt.value">{{ opt.label }}</option>
            </select>
            <button type="button" *ngIf="canUpdate" (click)="removeFromMore(cat, item)"
              class="p-2 rounded-lg border border-rose-200 text-rose-500 hover:bg-rose-50 dark:hover:bg-rose-950/40"
              title="เอาออกจากหมวดนี้">
              <span class="material-icons text-base">remove_circle_outline</span>
            </button>
          </div>
          <p *ngIf="!cat.items?.length" class="p-4 text-xs text-slate-400 text-center">ยังไม่มีรายการในหมวดนี้</p>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="isImportModalOpen()"
  class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm">
  <div class="bg-white dark:bg-slate-900 rounded-2xl shadow-2xl max-w-lg w-full p-6 border border-slate-100 dark:border-slate-800">
    <div class="flex items-center justify-between mb-4">
      <h3 class="text-lg font-bold text-slate-800 dark:text-slate-100">ยืนยันนำเข้า JSON</h3>
      <button type="button" (click)="closeImportModal()"><span class="material-icons text-slate-400">close</span></button>
    </div>
    <p class="text-sm text-slate-500 mb-4">ไฟล์: {{ selectedFileName() }}</p>
    <div class="grid grid-cols-2 md:grid-cols-4 gap-3 mb-6">
      <div class="text-center p-3 rounded-xl bg-slate-50 dark:bg-slate-800">
        <div class="text-xl font-bold text-slate-600">{{ importSummary().catalogCount }}</div>
        <div class="text-xs text-slate-400">คลัง</div>
      </div>
      <div class="text-center p-3 rounded-xl bg-slate-50 dark:bg-slate-800">
        <div class="text-xl font-bold text-amber-500">{{ importSummary().quickCount }}</div>
        <div class="text-xs text-slate-400">Quick</div>
      </div>
      <div class="text-center p-3 rounded-xl bg-slate-50 dark:bg-slate-800">
        <div class="text-xl font-bold text-indigo-500">{{ importSummary().moreCategories }}</div>
        <div class="text-xs text-slate-400">หมวด More</div>
      </div>
      <div class="text-center p-3 rounded-xl bg-slate-50 dark:bg-slate-800">
        <div class="text-xl font-bold text-emerald-500">{{ importSummary().moreItems }}</div>
        <div class="text-xs text-slate-400">รายการ More</div>
      </div>
    </div>
    <div class="flex justify-end gap-2">
      <button type="button" (click)="closeImportModal()" class="px-4 py-2 rounded-xl border font-bold">ยกเลิก</button>
      <button type="button" (click)="confirmImport()" [disabled]="isSaving()"
        class="px-4 py-2 rounded-xl bg-amber-400 text-white font-bold disabled:opacity-50">ยืนยันนำเข้า</button>
    </div>
  </div>
</div>

<!-- Catalog create/edit form -->
<div *ngIf="isCatalogFormOpen()"
  class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm overflow-y-auto">
  <div class="bg-white dark:bg-slate-900 rounded-2xl shadow-2xl max-w-2xl w-full my-4 p-6 border border-slate-100 dark:border-slate-800">
    <div class="flex items-center justify-between mb-4">
      <h3 class="text-lg font-bold text-slate-800 dark:text-slate-100">
        {{ catalogFormMode() === 'create' ? 'เพิ่มเมนูในคลัง' : 'แก้ไขเมนูในคลัง' }}
      </h3>
      <button type="button" (click)="closeCatalogForm()"><span class="material-icons text-slate-400">close</span></button>
    </div>
    <p class="text-xs text-amber-600 mb-4">ฟิลด์ที่บังคับ (*) ต้องกรอกครบ — LIFF Home ใช้ค่าเหล่านี้โดยตรง</p>
    <div class="grid grid-cols-1 md:grid-cols-2 gap-3 text-sm">
      <label class="block">
        <span class="text-xs font-bold text-slate-500">key *</span>
        <input class="mt-1 w-full rounded-xl border border-slate-200 dark:border-slate-700 px-3 py-2 bg-white dark:bg-slate-950 font-mono"
          [ngModel]="catalogForm().key" (ngModelChange)="patchCatalogForm({ key: $event })" placeholder="my_cars" />
      </label>
      <label class="block">
        <span class="text-xs font-bold text-slate-500">route * (LIFF path ไม่มี / นำหน้า)</span>
        <input class="mt-1 w-full rounded-xl border border-slate-200 dark:border-slate-700 px-3 py-2 bg-white dark:bg-slate-950 font-mono"
          [ngModel]="catalogForm().route" (ngModelChange)="patchCatalogForm({ route: $event })" placeholder="vehicles-option" />
      </label>
      <label class="block">
        <span class="text-xs font-bold text-slate-500">nameTH *</span>
        <input class="mt-1 w-full rounded-xl border border-slate-200 dark:border-slate-700 px-3 py-2 bg-white dark:bg-slate-950"
          [ngModel]="catalogForm().nameTH" (ngModelChange)="patchCatalogForm({ nameTH: $event })" />
      </label>
      <label class="block">
        <span class="text-xs font-bold text-slate-500">nameEN *</span>
        <input class="mt-1 w-full rounded-xl border border-slate-200 dark:border-slate-700 px-3 py-2 bg-white dark:bg-slate-950"
          [ngModel]="catalogForm().nameEN" (ngModelChange)="patchCatalogForm({ nameEN: $event })" />
      </label>
      <label class="block md:col-span-2">
        <span class="text-xs font-bold text-slate-500">image * (เช่น /icons/car-home.png)</span>
        <input class="mt-1 w-full rounded-xl border border-slate-200 dark:border-slate-700 px-3 py-2 bg-white dark:bg-slate-950 font-mono"
          [ngModel]="catalogForm().image" (ngModelChange)="patchCatalogForm({ image: $event })" />
      </label>
      <label class="block">
        <span class="text-xs font-bold text-slate-500">imageSlide (ว่าง = ใช้ image)</span>
        <input class="mt-1 w-full rounded-xl border border-slate-200 dark:border-slate-700 px-3 py-2 bg-white dark:bg-slate-950 font-mono"
          [ngModel]="catalogForm().imageSlide" (ngModelChange)="patchCatalogForm({ imageSlide: $event })" />
      </label>
      <label class="block">
        <span class="text-xs font-bold text-slate-500">imageActive (ว่าง = ใช้ image)</span>
        <input class="mt-1 w-full rounded-xl border border-slate-200 dark:border-slate-700 px-3 py-2 bg-white dark:bg-slate-950 font-mono"
          [ngModel]="catalogForm().imageActive" (ngModelChange)="patchCatalogForm({ imageActive: $event })" />
      </label>
      <label class="block">
        <span class="text-xs font-bold text-slate-500">alt *</span>
        <input class="mt-1 w-full rounded-xl border border-slate-200 dark:border-slate-700 px-3 py-2 bg-white dark:bg-slate-950"
          [ngModel]="catalogForm().alt" (ngModelChange)="patchCatalogForm({ alt: $event })" />
      </label>
      <label class="block">
        <span class="text-xs font-bold text-slate-500">alert (รหัส badge บน Home)</span>
        <input class="mt-1 w-full rounded-xl border border-slate-200 dark:border-slate-700 px-3 py-2 bg-white dark:bg-slate-950"
          [ngModel]="catalogForm().alert" (ngModelChange)="patchCatalogForm({ alert: $event })" placeholder="vehiclesOption" />
      </label>
      <label class="block">
        <span class="text-xs font-bold text-slate-500">action (เช่น more)</span>
        <input class="mt-1 w-full rounded-xl border border-slate-200 dark:border-slate-700 px-3 py-2 bg-white dark:bg-slate-950"
          [ngModel]="catalogForm().action" (ngModelChange)="patchCatalogForm({ action: $event })" />
      </label>
      <label class="block">
        <span class="text-xs font-bold text-slate-500">visibility *</span>
        <select class="mt-1 w-full rounded-xl border border-slate-200 dark:border-slate-700 px-3 py-2 bg-white dark:bg-slate-950"
          [ngModel]="catalogForm().visibility" (ngModelChange)="patchCatalogForm({ visibility: $event })">
          <option *ngFor="let opt of visibilityOptions" [value]="opt.value">{{ opt.label }}</option>
        </select>
      </label>
      <label class="block">
        <span class="text-xs font-bold text-slate-500">disableTextTH *</span>
        <input class="mt-1 w-full rounded-xl border border-slate-200 dark:border-slate-700 px-3 py-2 bg-white dark:bg-slate-950"
          [ngModel]="catalogForm().disableTextTH" (ngModelChange)="patchCatalogForm({ disableTextTH: $event })" />
      </label>
      <label class="block">
        <span class="text-xs font-bold text-slate-500">disableTextEN *</span>
        <input class="mt-1 w-full rounded-xl border border-slate-200 dark:border-slate-700 px-3 py-2 bg-white dark:bg-slate-950"
          [ngModel]="catalogForm().disableTextEN" (ngModelChange)="patchCatalogForm({ disableTextEN: $event })" />
      </label>
    </div>
    <div class="flex justify-end gap-2 mt-6">
      <button type="button" (click)="closeCatalogForm()" class="px-4 py-2 rounded-xl border font-bold">ยกเลิก</button>
      <button type="button" (click)="saveCatalogForm()"
        class="px-4 py-2 rounded-xl bg-amber-400 text-white font-bold">
        {{ catalogFormMode() === 'create' ? 'เพิ่มในคลัง' : 'อัปเดต' }}
      </button>
    </div>
  </div>
</div>

<app-modal-admin-activity-history
  *ngIf="showActivityHistory"
  [entityType]="activityEntityTypes.LiffHomeMenuConfig"
  [entityId]="globalEntityId"
  title="ประวัติเมนู LIFF Home"
  (close)="closeActivityHistory()">
</app-modal-admin-activity-history>
